import db from '../db'

const getSteps = () =>
  db
    .collection('backend')
    .doc('quote')
		.get()
    .then((quote) => quote.data())
		.then(({ steps }) => steps)
    .catch((error) => {
        console.log("Error getting steps: ", error);
    });

		

export default getSteps;
